module.exports = __webpack_public_path__ + "prize-claimed.08ec4f2.jpg";